import { useState } from "react";

export function useQualityModal() {
  const [qualityModal, setQualityModal] = useState({
    open: false,
    type: null,
  });

  const openQualityModal = (type) => {
    setQualityModal({
      open: true,
      type,
    });
  };

  const closeQualityModal = () => {
    setQualityModal({
      open: false,
      type: null,
    });
  };

  return {
    qualityModal,
    setQualityModal,
    openQualityModal,
    closeQualityModal,
  };
}